import { environment as baseEnv } from './environment.dev'

export const environment = {
  ...baseEnv,
  environmentKey: 'dev-alt-14',
  apiUrl: 'https://dev-alt-14-api.eshyft.com/api/v2',
  socketUrl: 'https://dev-alt-14-api.eshyft.com',
  firebaseTenantId: 'dev-alt-14-g7d6o',
  verifyOtpUrl: 'https://verify-otp-lgtjqnr75q-uk.a.run.app'
}
